module.exports = __webpack_public_path__ + "img/95a4e1c.jpg";